<template>
	<div class="international" ref="createorder">
		<el-form ref="createorderform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'scroll' }">
			<el-row>
				<el-col v-for="(item, index) in model1" :key="index" :span="24" v-if="item.l_mode == '订单号' && item.ishidden == 'False' && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.showname" shadow="hover">
						<span>订单号</span>
						<el-input style="width:200px;margin-left:10px;" size="mini" type="text" :disabled="isEnable" v-model="p_pkval"></el-input>
						<i class="el-icon-edit" v-if="isEnable && pkval == ''" @click="isEnable = false" style="marign-left:50px;cursor:pointer;"></i>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :key="index" :span="24" v-if="item.l_mode == '门店' && item.ishidden == 'False'">
					<el-card class="box-card" label="选择门店" shadow="hover">
						<div slot="header" class="clearfix"><span>选择门店</span></div>
						<div class="chooseShopBox">
							<div :class="chooseshopindex == idx ? 'chooseShop active' : 'chooseShop'" v-for="(i, idx) in item.colsource" :key="idx" @click="chooseShop(idx, index)">
								<div class="shopTitle">{{ i.s_name }}</div>
								<div class="shopContent">{{ i.remark }}</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :key="index" :span="24" v-if="item.l_mode == '渠道' && clearancelist.length > 1">
					<el-card class="box-card" label="选择渠道" shadow="hover">
						<div slot="header" class="clearfix"><span>选择渠道</span></div>
						<div class="chooseShopBox">
							<div
								:class="chooseclearanceindex == idx ? 'chooseShop active' : 'chooseShop'"
								v-for="(i, idx) in item.colsource"
								:key="idx"
								@click="chooseclearance(idx, index)"
							>
								<div class="shopTitle">{{ i.d_name }}</div>
								<div class="shopContent">{{ i.remark }}</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :key="index" :span="12" v-if="(item.l_mode == '寄件人信息' || item.l_mode == '收件人信息') && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.l_mode" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_mode }}</span>
						</div>
						<div class="inputBox">
							<el-form-item
								v-if="i.ishidden == 'False'"
								:class="['inputItem', i.controltype == 'textarea' ? 'col24' : 'col12']"
								:label="i.showname"
								label-width="80px"
								v-for="(i, idx) in item.children"
								:key="idx"
								size="mini"
							>
								<el-input
									v-if="i.controltype == 'text' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									:ref="i.colname"
									@blur="val => checkinput(val, i, index)"
									@keyup.native="val => enterinput(val, i, index)"
								></el-input>
								<el-input
									v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									type="text"
									v-model="i.value"
									:ref="i.colname"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
								></el-input>
								<el-autocomplete
									:ref="i.colname"
									v-if="i.controltype == 'input_filter'"
									v-model="i.value"
									:fetch-suggestions="
										(queryString, cb) => {
											inputsuggestions(queryString, cb, i, index);
										}
									"
									:style="{ width: `${i.coltdwidth}px` }"
									value-key="showname"
									:trigger-on-focus="true"
									@keyup.native="val => enterinput(val, i, index)"
									@select="
										val => {
											handleSelect(val, i, index);
										}
									"
								></el-autocomplete>
								<!-- 地址联动 -->
								<el-select
									:ref="i.colname"
									v-model="i.value"
									filterable
									remote
									reserve-keyword
									placeholder="可输入关键词搜索"
									:remote-method="val => addrinput(val, i, index)"
									:loading="loading"
									v-if="i.controltype == 'addrinput' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option disabled label="可输入关键词搜索" value=""></el-option>
									<el-option v-for="(item,idex) in i.colsource" :key="idex" :label="item.showname" :value="item.showname"></el-option>
								</el-select>

								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									class="input-with-search"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<div slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index, idx)">
										<span style="padding:15px"><i class="el-icon-search"></i></span>
									</div>
								</el-input>

								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
									:type="i.controltype"
									v-model="i.value"
									@keyup.native="val => enterinput(val, i, index)"
								></el-input>
								<el-select
									:ref="i.colname"
									v-model="i.value"
									filterable
									remote
									reserve-keyword
									placeholder="可输入关键词搜索"
									:remote-method="val => remoteMethod(val, i, index)"
									:loading="loading"
									v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option disabled label="可输入关键词搜索" value=""></el-option>
									<el-option v-for="(item,idex) in i.colsource" :key="idex" :label="item.title" :value="item.value"></el-option>
								</el-select>
								<el-select
									:ref="i.colname"
									v-model="i.value"
									v-if="i.controltype == 'select' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
								<!-- :style="{width:`${i.coltdwidth}px`}" -->
								<el-checkbox
									v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
									:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
									:checked="i.coldefault == 1 ? true : false"
									@change="val => setcheck(val, i)"
								></el-checkbox>

								<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
							</el-form-item>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :span="24" v-if="item.l_mode == '包裹信息' && item.ishidden == 'False'" :key="index">
					<el-card class="box-card" :label="item.showname" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_mode }}</span>
						</div>
						<div>
							<el-row>
								<el-col v-for="(i, idx) in item.children" :key="idx" :span="8">
									<el-form-item
										v-if="i.controltype != 'table' && i.ishidden == 'False'"
										:class="['inputItem', i.controltype == 'textarea' ? 'col24' : 'col12']"
										:label="i.showname"
										label-width="80px"
										size="mini"
									>
										<label v-if="i.controltype == 'checkbox' && i.ishidden == 'False'">
											<el-checkbox
												:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
												v-model="i.value"
												:true-label="1"
												:false-label="0"
												:checked="i.value == '1' ? true : false"
											></el-checkbox>
										</label>
										<el-autocomplete
											:ref="i.colname"
											v-if="i.controltype == 'input_filter'"
											v-model="i.value"
											:fetch-suggestions="
												(queryString, cb) => {
													inputsuggestions(queryString, cb, i, index);
												}
											"
											:style="{ width: `${i.coltdwidth}px` }"
											value-key="showname"
											:trigger-on-focus="true"
											@keyup.native="val => enterinput(val, i, index)"
											@select="
												val => {
													handleSelect(val, i, index);
												}
											"
										></el-autocomplete>
										<el-select
											:ref="i.colname"
											v-model="i.value"
											v-if="i.controltype == 'select'"
											:style="{ width: `${i.coltdwidth}px` }"
											@change.native="val => enterinput(val, i, index)"
										>
											<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
										</el-select>
										<div v-if="i.controltype == 'combox-input'" class="tiji">
											<span v-for="(tj, ti) in i.combox" :key="ti">
												{{ tj.showname }}
												<el-input style="width:50px;margin-right:10px" v-model="tj.value"></el-input>
											</span>
										</div>
										<div v-if="i.controltype == 'combox-input-postfix'">
											<el-input
												:ref="i.colname"
												v-model="i.value"
												class="input-with-span"
												type="text"
												
												@keyup.native="val => enterinput(val, i, index)"
											>
											<div slot="prepend">
												<span style="padding:15px">{{ i.combox[0].showname }}</span>
											</div>
											<div slot="append">
												<span :style="{color:i.combox[2].isnull=='True'?'#000000':'#ff0000'}">{{ i.combox[2].showname }}</span>
											</div>
											</el-input>
										</div>
										<el-input
											:ref="i.colname"
											v-model="i.value"
											type="text"
											:style="{ width: `${i.coltdwidth}px` }"
											v-if="i.controltype == 'text'"
											@keyup.native="val => enterinput(val, i, index)"
										></el-input>
										<el-input
											:ref="i.colname"
											v-model="i.value"
											type="textarea"
											:style="{ width: `${i.coltdwidth}px` }"
											v-if="i.controltype == 'textarea'"
											@keyup.native="val => enterinput(val, i, index)"
										></el-input>
										<div v-if="i.controltype == 'combox-checkbox' && i.ishidden == 'False'">
											<el-checkbox
												:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
												true-label="1"
												false-label="0"
												:checked="i.value != '' && i.value != '0.00' ? true : false"
												@change="val => checkchange(val, i.colname, i)"
											></el-checkbox>
											<el-input
												:style="{
													width: `${i.coltdwidth}px`,
													marginLeft: `10px`,
													display: `${i.value != '' && i.value != '0.00' ? 'inline-block' : 'none'}`
												}"
												:ref="i.colname"
												type="text"
												v-model="i.value"
												placeholder="请输入保险金额"
												@keyup.native="val => enterinput(val, i, index)"
											></el-input>
										</div>
									</el-form-item>
								</el-col>
							</el-row>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :key="index" :span="24" v-if="item.l_mode == '附加信息' && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.l_mode" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_mode }}</span>
						</div>
						<div class="inputBox">
							<el-form-item
								:class="['inputItem', i.controltype == 'textarea' ? 'col12' : 'col12']"
								:label="i.showname"
								label-width="80px"
								v-for="(i, idx) in item.children"
								:key="idx"
								v-if="i.ishidden == 'False'"
								size="mini"
							>
								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'text' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									@keyup.native="val => enterinput(val, i, index)"
								></el-input>
								<el-input :ref="i.colname" v-if="i.controltype == 'textarea' && i.ishidden == 'False'" :type="i.controltype" v-model="i.value"></el-input>
								<el-select :ref="i.colname" v-if="i.controltype == 'select' && i.ishidden == 'False'" v-model="i.value" :style="{ width: `${i.coltdwidth}px` }">
									<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
								<el-checkbox
									v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
									:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
									v-model="i.coldefault"
									:checked="i.coldefault == 1 ? true : false"
								></el-checkbox>
								<div v-if="i.controltype == 'combox-checkbox' && i.ishidden == 'False'">
									<el-checkbox
										style="width:200px"
										true-label="1"
										false-label="0"
										:checked="i.value != '' && i.value != '0.00' ? true : false"
										@change="val => checkchange(val, i.colname, i)"
									></el-checkbox>
									<el-input
										:style="{ width: `${i.coltdwidth}px`, marginLeft: `10px`, display: `${i.value != '' && i.value != '0.00' ? 'inline-block' : 'none'}` }"
										:ref="i.colname"
										type="text"
										v-model="i.value"
										placeholder="请输入保险金额"
										@keyup.native="val => enterinput(val, i, index)"
									></el-input>
								</div>
								<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
							</el-form-item>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row v-if="model1.length > 0">
				<el-col :span="14" class="submitBtn"><div @click="getrate">获取报价</div></el-col>
			</el-row>
		</el-form>
		<el-dialog :visible.sync="showratewin" title="报价单" width="700px" :close-on-click-modal="false" lock-scroll :append-to-body="true" :show-close="true">
			<el-form ref="form" label-width="80px" size="mini">
				<el-form-item label="物流公司">
					<el-select v-model="expresscom" @change="searchexpresscom" style="width:260px">
						<el-option v-for="(item,idex) in expresscomlist" :key="idex" :label="item.expresscom" :value="item.expresscom"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<tableui
				style="width:100%;margin-top:-10px"
				v-loading="loading"
				ref="ratelist"
				editcell="0"
				class="ratelist"
				:tableData="ratelist"
				:columns="columns"
				@gridhandle="rategridhandle"
				:gridheight="gridheight"
			></tableui>
		</el-dialog>
		<el-dialog :visible.sync="showaddrwin" title="地址簿" width="600px" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true">
			<addresslist
				:type="addrtype"
				:addrsearchkey="addrsearchkey"
				:modelindex="modelindex"
				:childrenindex="childrenindex"
				ref="addresslist"
				@rebackaddr="rebackaddr"
			></addresslist>
		</el-dialog>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="550px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<p style="font-size:20pt;font-weight: bold">下单成功</p>
					<p style="font-size:16pt;font-weight: bold;color:#FF0000">请务必先打印海关文件</p>
				</el-col>
			</el-row>
			<el-row v-if="showpdf != ''">
				<el-col :span="4" style="text-align:right;padding-right: 20px;">
					<el-button type="danger" size="small"><a :href="customerpdf" target="_blank" style="color:#ffffff;text-decoration:none;">海关文件</a></el-button>
				</el-col>
				<el-col :span="5" style="text-align:right;padding-right: 20px;">
					<el-button type="warning" size="small" @click="perviewmd">
						预览面单
					</el-button>
				</el-col>
				<el-col :span="6"><el-button type="primary" size="small" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="4"><el-button type="success" size="small" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="4" style="text-align: right;"><el-button size="small" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			<el-row v-if="showpdf != ''" style="margin-top:25px">
				<el-col :span="20">
					<el-link @click="wintips=true" style="color:#409EFF">预览没反应？请点这里查看解决方案</el-link>
				</el-col>
			</el-row>
			<el-row v-if="showpdf == ''">
				<el-col :span="9" style="text-align:right;"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="9" style="text-align:center;"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="6" style="text-align:left;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
		<el-dialog :visible.sync="wintips" center width="70%" :close-on-click-modal="true" :show-close="true" :append-to-body="true">
			<img src="../../static/system_01/image/tips.png" style="width:100%" />
		</el-dialog>
		<printhandler ref="printhandler"></printhandler>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
import sendtype from '@/components/order/sendtype.vue';
import addresslist from '@/components/address/addresslist.vue';
import printhandler from '@/components/order/printhandler.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		sendtype,
		addresslist,
		printhandler
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		},
		curpkval: {
			type: String,
			default: ''
		},
		iscopy: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			chooseclearanceindex: 0,
			chooseshopindex: 0,
			windowHeight: window.innerHeight - 120,
			model1: [],
			shopname: '',
			p_mode: '',
			isEnable: true,
			pkval: '', //修改时此值不为空
			p_pkval: '',
			cargolist: [],
			orderinfo: {},
			mode: '',
			btnhidden: true, //显示保存按钮
			btntext: '保存',
			checkedpmode: '', //已选择的渠道
			clearancelist: [],
			btnrate: true, //隐藏获取报价按钮
			footerbtn_order: [{ name: '确定', event: 'saveorder', type: 'primary' }],
			isprint: false, //是否直接打印
			isperview: false, //是否下单后预览面单
			ratelist: [], //报价单
			columns: [
				{ field: 'expresscom', title: '物流公司', type: 'text', sortable: false },
				{ field: 'servicetype', title: '线路名称', type: 'text', sortable: false },
				{ field: 'amount', title: '价格', type: 'text', sortable: false, align: 'right' },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '130',
					sortable: false,
					template: [{ type: 'link', title: '创建订单', icon: '', handletype: 'success', event: 'createorder' }]
				}
			], //报价单列表表头
			loading: false,
			showratewin: false,
			gridheight: (window.innerHeight * 50) / 100 + 'px',
			expresscom: '',
			expresscomlist: [{ expresscom: '全部' }, { expresscom: 'Fedex' }, { expresscom: 'USPS' }, { expresscom: 'UPS' }],
			expresscomname:'',
			expresscomid: '', //选择的物流公司唯一id
			rateid: '', //报价单唯一id
			servicetypeid: '', //服务类型编码
			residential: 0, //寄件地址是否为家庭住址
			cgresidential: 0, //收件地址是否为家庭住址
			showpdf: '1', //面单地址
			allratelist: [], //所有已筛选的值
			//iscopy: 0 ,//是否复制新增
			showaddrwin: false,
			addrtype: '0', //地址标识 1-寄件地址 0-收件地址
			modelindex: -1,
			childrenindex: -1,
			addrsearchkey: '',
			type: 'DHL国际件',
			showsuccesswin: false,
			addressinfo: '', //默认寄件地址
			ecode: '',
			divclass: 'ratelist',
			vipaccount: '',
			customerpdf: '',
			wintips:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/logisticsmanager/international.scss');
		});
		if (this.iscopy == 1) this.p_pkval = '';
		var that = this;
		//设置列表兼容性
		setTimeout(() => {
			if (that.$refs.cargo != undefined) {
				if (that.$refs.cargo.length > 0) {
					that.$refs.cargo[0].$refs.tablegrid.doLayout();
				}
			}
		}, 300);
		this.vipaccount = localStorage.getItem('vipaccount');
	},
	methods: {
		init(param) {
			this.$tool.loading('正在加载', 'international');
			this.GetDefaultaddr();
		},
		//获取默认寄件地址
		GetDefaultaddr() {
			var that = this;
			this.$apipost.get.GetDefaultCtaddr().then(res => {
				if (res.addressinfo != undefined && res.addressinfo != '') {
					that.addressinfo = res.addressinfo;
				}
				this.GetClarance(-1);
			});
		},
		//排版
		GetPageLayout() {
			var that = this;
			if (that.curpkval != '') {
				this.$apipost.get.GetOrderInfo({ pkval: that.curpkval }).then(order => {
					if (order != '') {
						if (that.iscopy == 1) {
							that.pkval = '';
						} else {
							that.pkval = curpkval;
						}
						that.orderinfo = order.orderinfo;
						that.checkedpmode = that.orderinfo.p_mode;
						that.GetPageLayoutSet();
					}
				});
			} else {
				that.GetPageLayoutSet();
			}
		},
		//获取排版信息
		GetPageLayoutSet() {
			var that = this;

			this.$apipost.get.CreatePageLayoutByPmode({ sys: '出口系统', fun: '国际件下单', type: this.type, p_mode: '' }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if (res.list.length > 0) {
						that.model1 = [];
						that.SetPageLayout(res.list);
					}
				}
			});
		},
		//设置排版
		SetPageLayout(list) {
			var index = 0;
			var that = this;
			var isorderinfo = true;
			if (that.orderinfo.p_pkval == undefined) {
				//说明未获取到订单信息
				isorderinfo = false;
			}
			that.model1 = list;
			list.forEach(e => {
				if (e.ishidden == 'False') {
					if (e.l_mode == '门店') {
						that.GetShop(index);
					}
					if (e.l_mode == '渠道') {
						that.GetClarance(index);
					}
					if (e.l_mode == '包裹信息') {
						e.children.forEach(cargo => {
							if (cargo.tablename == 'sp_pt_cargo' && cargo.ishidden == 'False') {
								if (isorderinfo) {
									if (that.orderinfo.cargolist != undefined) {
										that.cargolist = that.orderinfo.cargolist;
										for (var key in that.orderinfo.cargolist[0]) {
											if (cargo.colname == key) {
												cargo.value = that.orderinfo.cargolist[0][key];
											}
										}
									}
								} else {
									cargo.value = cargo.coldefault;
								}
							} else {
								if (isorderinfo) {
									if (cargo.controltype == 'combox-input' && cargo.ishidden == 'False') {
										var volume = cargo.combox;
										cargo.combox.forEach(com => {
											for (var key in that.orderinfo.baginfo) {
												if (com.colname == key) {
													com.value = that.orderinfo.baginfo[key];
												}
											}
										});
									} else {
										if (cargo.ishidden == 'False') {
											for (var key in that.orderinfo.baginfo) {
												if (cargo.colname == key) {
													cargo.value = that.orderinfo.baginfo[key];
												}
											}
										}
									}
								}
							}
						});
					}
					if (e.l_mode == '寄件人信息') {
						if (isorderinfo) {
							e.children.forEach(sender => {
								for (var key in that.orderinfo.sender) {
									if (sender.colname == key) {
										sender.value = that.orderinfo.sender[key];
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								}
							});
						} else {
							e.children.forEach(sender => {
								if (that.addressinfo != '') {
									var addressinfo = JSON.parse(JSON.stringify(that.addressinfo));
									for (var key in addressinfo) {
										if (sender.colname == key) {
											sender.value = addressinfo[key];
										}
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								} else {
									sender.value = sender.coldefault;
								}
							});
						}
					}
					if (e.l_mode == '收件人信息') {
						if (isorderinfo) {
							e.children.forEach(receiver => {
								for (var key in that.orderinfo.receiver) {
									if (receiver.colname == key) {
										receiver.value = that.orderinfo.receiver[key];
										if (receiver.value == '' || receiver.value == undefined) {
											receiver.value = receiver.coldefault;
										}
									}
								}
							});
						} else {
							e.children.forEach(receiver => {
								if (receiver.value == '' || receiver.value == undefined) {
									receiver.value = receiver.coldefault;
								}
							});
						}
					}
					if (e.l_mode == '附加信息') {
						if (isorderinfo) {
							e.children.forEach(orderextend => {
								for (var key in that.orderinfo.extend) {
									if (orderextend.colname == key) {
										orderextend.value = that.orderinfo.extend[key];
									}
								}
							});
						}
					}
				}
				index++;
			});
		},
		//门店
		GetShop(index) {
			var that = this;
			this.$apipost.get.GetShopList().then(res => {
				that.shopname = res.list[0].s_name;
				if (res.list.length == 1) {
					that.model1[index].ishidden = 'True';
					that.s_address = res.list[0].s_address;
				} else {
					that.model1[index].colsource = res.list;
					var currentindex = 0;
					res.list.forEach(e => {
						if (e.checked == 1) {
							that.chooseshopindex = currentindex;
						}
						currentindex++;
					});
					that.s_address = that.model1[index].colsource[that.chooseshopindex].s_address;
				}
			});
		},
		//清关渠道
		GetClarance(index) {
			var that = this;
			if (index > -1) {
				// if (that.clearancelist.length <= 1) {
				// 	that.model1[index].ishidden = 'True';
				// }
				if (that.pkval != undefined && that.pkval != '') {
					//表示修改
					that.p_mode = that.orderinfo.p_mode + ',' + that.orderinfo.mode; //并且设置当前加载的项目为选中状态
				} else {
					if (that.p_mode == '') that.p_mode = that.clearancelist[0].d_name + ',' + that.clearancelist[0].d_value;
				}
				that.model1[index].colsource = that.clearancelist;
				var list = that.clearancelist;
				for (var i = 0; i < list.length; i++) {
					if (list[i].d_name + ',' + list[i].d_value == that.p_mode) {
						that.chooseclearanceindex = i;
						break;
					}
				}
			} else {
				this.$apipost.get.GetClarance().then(res => {
					that.clearancelist = res.list;
					if (that.clearancelist.length > 0) {
						that.checkedpmode = that.clearancelist[0].d_name;
					}
					that.GetPageLayout();
				});
			}
		},
		//根据界面布局，设置包裹信息列
		setcargocol(colset) {
			var cargo = '';
			colset.forEach(e => {
				if (e.type != 'template') {
					cargo += '"' + e.field + '":"",';
				}
			});
			if (cargo != '') {
				cargo = cargo.substring(0, cargo.length - 1);
			}
			cargo = '[{' + cargo + '}]';
			this.cargolist = JSON.parse(cargo);
		},
		gridhandle(e) {
			if (e.event == 'delrow') {
				this.deleteRow(e);
			}
		},
		//报价单列表操作事件
		rategridhandle(e) {
			var that = this;
			if (e.event == 'createorder') {
				//弹出确定框
				this.$confirm('您已选择 ' + e.row.expresscom + ' 的【' + e.row.servicetype + '】服务,预估费用 【' + e.row.amount + '】 ,确认下单吗?', '提示', {
					cancelButtonText: '否',
					confirmButtonText: '是',
					type: 'success',
					showClose: false,
					closeOnClickModal: false
				})
					.then(res => {
						if (res == 'confirm') {
							that.rateid = e.row.id;
							that.expresscomname=e.row.expresscom;
							that.expresscomid = e.row.e_code; //下单唯一id
							that.servicetypeid = e.row.servicetypeid; //
							that.residential = e.row.residential;
							that.cgresidential = e.row.cgresidential;
							that.p_mode = e.row.p_mode;
							that.saveorder();
						}
					})
					.catch(() => {});
			}
		},
		//添加商品行
		addcargorow() {
			var row = this.clearcargorow(this.cargolist[0]);
			this.cargolist.push(row);
		},
		//清空包裹列表内的值
		clearcargorow(row) {
			var newrow = JSON.parse(JSON.stringify(row));
			for (var key in newrow) {
				newrow[key] = '';
			}
			return newrow;
		},
		//删除商品行
		deleteRow(e) {
			if (this.cargolist.length > 1) {
				this.cargolist.splice(e.index, 1);
			} else {
				var newrow = this.clearcargorow(this.cargolist[0]);
				this.cargolist.splice(e.index, 1);
				this.cargolist.push(newrow);
			}
		},
		//选择渠道
		chooseclearance(index, modelindex) {
			this.chooseclearanceindex = index;
			this.p_mode = this.model1[modelindex].colsource[index].d_name + ',' + this.model1[modelindex].colsource[index].d_value;
			this.checkedpmode = this.model1[modelindex].colsource[index].d_name;
			this.orderinfo = this.getorderObj(this.model1, this.orderinfo, false);
			//切换口岸时查找对应的布局
			this.GetPageLayout();
		},
		//选择门店
		chooseShop(index, modelindex) {
			this.chooseshopindex = index;
			this.shopname = this.model1[modelindex].s_name;
			this.s_address = this.model1[modelindex].colsource[index].s_address;
		},
		//保存订单
		saveorder() {
			var that = this;
			var isgo = true;
			var orderinfo = {};
			orderinfo = that.getorderObj(JSON.parse(JSON.stringify(this.model1)), orderinfo, true);
			if (orderinfo.receiver != undefined) {
				this.$tool.loading('正在保存', 'international');
				//console.log('正在保存 ' + this.$tool.getcurrenttime());
				//console.log('orderinfo', JSON.stringify(orderinfo));
				// if(1>0){
				// 	return false;
				// }
				this.$apipost.post.SavelogisticsOrder({ orderinfo: orderinfo }).then(res => {
					that.servicetype = '';
					if (res != '') {
						this.$tool.loadingclose();
						if (res.state == '1') {
							that.p_pkval=res.pkval;
							that.goprint(res.pkval);
						} else {
							this.$tool.message(res.message, 0);
						}
					}
				});
			}
		},
		//获取订单实体信息
		getorderObj(model1, orderinfo, iserror) {
			var that = this;
			if (this.iscopy == 1) {
				this.pkval = '';
			}
			orderinfo = {
				u_userid: localStorage.getItem('userid'),
				u_account: localStorage.getItem('u_account'),
				u_name: localStorage.getItem('u_name'),
				u_company: localStorage.getItem('u_company'),
				pkval: this.pkval,
				p_pkval: this.p_pkval,
				servicetype: this.servicetypeid,
				p_mode:this.p_mode
			};
			var error = '';
			for (var i = 0; i < model1.length; i++) {
				if (model1[i].l_mode == '订单号') {
					orderinfo.p_pkval = that.p_pkval;
				}
				if (model1[i].l_mode == '门店' && model1[i].ishidden == 'False') {
					orderinfo.shopname = that.shopname;
					if (orderinfo.shopname == '') {
						error = '请选择' + model1[i].l_mode;
						if (iserror) {
							break;
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '渠道' && model1[i].ishidden == 'False') {
						orderinfo.p_mode = that.p_mode.split(',')[0];
						orderinfo.mode = that.p_mode.split(',')[1];
						if (orderinfo.p_mode == '' && iserror) {
							error = '请选择' + model1[i].l_mode;
							if (iserror) {
								break;
							}
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '寄件人信息' && model1[i].ishidden == 'False') {
						var sender = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].value == undefined) {
								children[j].value = '';
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写寄件人' + children[j].showname;
								if (iserror) {
									sender = '';
									break;
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									sender += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								sender += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (sender != '') {
							sender = sender.replace(/\n/g, '');
							sender = '{' + sender.substring(0, sender.length - 1) + '}';
							orderinfo.sender = JSON.parse(sender);
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '收件人信息' && model1[i].ishidden == 'False') {
						var receiver = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].value == undefined) {
								children[j].value = '';
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写收件人' + children[j].showname;
								if (iserror) {
									receiver = '';
									break;
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									receiver += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								receiver += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (receiver != '') {
							receiver = receiver.replace(/\n/g, '');
							receiver = '{' + receiver.substring(0, receiver.length - 1) + '}';
							orderinfo.receiver = JSON.parse(receiver);
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '包裹信息') {
						var isnocargo = true;
						var baginfo = '',
							cargo = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].tablename != 'sp_pt_cargo') {
								if (children[j].controltype == 'combox-input' && children[j].isnull == 'False') {
									var volume = children[j].combox;
									for (var k = 0; k < volume.length; k++) {
										if (volume[k].value == undefined) {
											volume[k].value = '';
										}
										if (volume[k].isnull == 'False' && volume[k].value == '') {
											error = '请填写' + volume[k].showname;
											if (iserror) {
												break;
											}
										}
										if (iserror) {
											if (volume[k].ishidden == 'False') baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
										} else {
											baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
										}
									}
									if (error != '') {
										if (iserror) {
											baginfo = '';
											break;
										}
									}
								} else {
									if (children[j].value == undefined) {
										children[j].value = '';
									}
									if (children[j].isnull == 'False' && children[j].value == '') {
										error = '请填写' + children[j].showname;
										if (iserror) {
											break;
										}
									}
									if (iserror) {
										if (children[j].ishidden == 'False') baginfo += '"' + children[j].colname + '":"' + children[j].value + '",';
									} else {
										baginfo += '"' + children[j].colname + '":"' + children[j].value + '",';
									}
								}
							} else {
								if (children[j].ishidden == 'False') {
									if (children[j].isnull == 'False') {										
										if (children[j].value == undefined || children[j].value == '') {
											error = '请填写' + children[j].showname;
											if (iserror) {
												break;
											}
										} else {
											if(children[j].colname=='cno')
												cargo += '"' + children[j].colname + '":"' + 'ECCN'+children[j].value + '",';
											else
												cargo += '"' + children[j].colname + '":"' + children[j].value + '",';
										}
									} else {
											if(children[j].colname=='cno')
												cargo += '"' + children[j].colname + '":"' + 'ECCN'+children[j].value + '",';
											else
												cargo += '"' + children[j].colname + '":"' + children[j].value + '",';
										}
								}
							}
						}
						if (error == '' || !iserror) {
							if (cargo != '') {
								cargo = cargo.replace(/\n/g, '');
								cargo = '[{' + cargo.substring(0, cargo.length - 1) + '}]';
								that.cargolist = JSON.parse(cargo);
								orderinfo.cargolist = that.cargolist;
							}
						}
						if (error == '' || !iserror) {
							if (baginfo != '') {
								baginfo = baginfo.replace(/\n/g, '');
								baginfo = '{' + baginfo.substring(0, baginfo.length - 1) + '}';
								orderinfo.baginfo = JSON.parse(baginfo);
							}
							var content = '';
							that.cargolist.forEach(e => {
								if (e.cnameall != undefined) {
									content += e.cnameall + ' ' + e.num + '  ';
								} else {
									if (e.brand != undefined) {
										content += e.brand + ' ';
									}
									if (e.cname != undefined) {
										content += e.cname + ' ';
									}
									if (e.spec != undefined) {
										content += e.spec + ' ';
									}
									content += e.num + ' ';
									if (e.unit != undefined) {
										content += e.unit + ' ';
									}
								}
							});
							orderinfo.p_content = content;
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '附加信息' && model1[i].ishidden == 'False') {
						var extend = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype == 'checkbox') {
								if (children[j].coldefault) {
									children[j].value = '1';
								} else {
									children[j].value = '0';
								}
							} else {
								if (children[j].value == undefined) {
									children[j].value = '';
								}
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写' + children[j].showname;
								if (iserror) {
									extend = '';
									break;
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									extend += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								extend += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (extend != '') {
							extend = extend.replace(/\n/g, '');
							extend = '{' + extend.substring(0, extend.length - 1) + '}';
							orderinfo.extend = JSON.parse(extend);
						}
					}
				}
				if (error != '' && iserror) {
					this.$tool.message(error, 0);
					break;
				}
			}
			if (error != '' && iserror) {
				orderinfo = {};
			}

			return orderinfo;
		},
		//获取报价单
		getrate() {
			var that = this;
			this.$tool.loadingclose();
			if (that.$refs.ratelist != undefined) {
				that.$refs.ratelist.$refs.tablegrid.doLayout();
			}
			var orderinfo = {};
			orderinfo = that.getorderObj(JSON.parse(JSON.stringify(this.model1)), orderinfo, true);
			orderinfo.vipaccount = that.vipaccount;
			orderinfo.international = '1';
			if (orderinfo.receiver != undefined) {
				// console.log('获取报价 ' + escape(JSON.stringify(orderinfo)));
				// if (2 > 1) return false;
				this.$tool.loading('正在获取', 'international');
				this.$apipost.get.GetRate({ orderinfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
					//	console.log('报价',res.ratelist);
						if (res.ratelist.length > 0) {
							that.showratewin = true;
							that.ratelist = res.ratelist;
							that.allratelist = res.ratelist;
						} else {
							if (res.message != undefined) {
								this.$tool.message(res.message, 0);
							} else {
								this.$tool.message('未获取到报价信息', 0);
							}
						}
					}
				});
			}
		},
		//打印
		goprint(pkval) {
			var that = this;
			var isrollback = false;
			//console.log('正在下单 ' + this.$tool.getcurrenttime());
			this.$tool.loading('正在下单', 'ratelist');
			that.ecode = that.expresscomid;
			if (that.$refs.printhandler != undefined) {
				if (that.pkval == '' || that.pkval == undefined) isrollback = true;
				that.$refs.printhandler.init({
					pageparam: this._data,
					isgrid: false,
					pkval: pkval,
					searchinfo: '',
					funcode: '07', //funcode --01从获取用户权限内的打印模板开始的
					handtype: 8, //1--取单号 2--取快递单并打印 3-取快递单并预览
					isrollback: isrollback,
					ecode: that.expresscomid,
					expresscomname:that.expresscomname,
					parentpage: this
				});
			}
		},
		//报价单筛选快递公司
		searchexpresscom(changevalue) {
			var allratelist = JSON.parse(JSON.stringify(this.allratelist));
			if (changevalue == '全部') {
				this.ratelist = allratelist;
			} else {
				//筛选
				this.ratelist = allratelist.filter(function(e) {
					return e.expresscom.toLowerCase().indexOf(changevalue.toLowerCase()) > -1;
				});
			}
		},
		//远程搜索option（国家）
		remoteMethod(query, i) {
			var that = this;
			if (query != '') {
				setTimeout(function() {
					if (i.colname.indexOf('country') > 0) {
						that.$apipost.get.GetCountry({ searchkey: query }).then(res => {
							if (res != '') {
								i.colsource = res.list;
							}
						});
					}
				}, 100);
			}
		},
		//带搜索的输入框
		inputgroupsearch(i, modelindex, childrenindex) {
			if (i.colname == 'ctcompany' || i.colname == 'ctname') {
				//按公司名搜索地址库
				this.addrtype = '1';
			} else if (i.colname == 'cgcompany' || i.colname == 'cgname') {
				this.addrtype = '0';
			}
			this.modelindex = modelindex;
			this.childrenindex = childrenindex;
			this.addrsearchkey = i.value;
			if (this.$refs.addresslist != undefined) {
				this.$refs.addresslist.init({ type: this.addrtype, addresskey: i.value, modelindex: modelindex, childrenindex: childrenindex });
			}
			this.showaddrwin = true;
		},
		//选地址回填
		rebackaddr(e) {
			var that = this;
			this.model1[e.modelindex].children.forEach(item => {
				if (that.addrtype == '1') {
					if (item.colname == 'ctcompany') item.value = e.row.company;
					if (item.colname == 'ctname') item.value = e.row.name;
					if (item.colname == 'ctphone') item.value = e.row.phone;
					if (item.colname == 'ctpostcode') item.value = e.row.postcode;
					if (item.colname == 'ctcountry') item.value = e.row.country;
					if (item.colname == 'ctprovince') item.value = e.row.province;
					if (item.colname == 'ctcity') item.value = e.row.city;
					if (item.colname == 'ctdetailaddr') item.value = e.row.street + e.row.detailaddr;
				} else {
					if (item.colname == 'cgcompany') item.value = e.row.company;
					if (item.colname == 'cgname') item.value = e.row.name;
					if (item.colname == 'cgphone') item.value = e.row.phone;
					if (item.colname == 'cgpostcode') item.value = e.row.postcode;
					if (item.colname == 'cgcountry') item.value = e.row.country;
					if (item.colname == 'cgprovince') item.value = e.row.province;
					if (item.colname == 'cgcity') item.value = e.row.city;
					if (item.colname == 'cgdetailaddr') item.value = e.row.street + e.row.detailaddr;
				}
			});
			this.showaddrwin = false;
		},
		//操作完成
		successfun(type) {
			var that = this;
			that.showsuccesswin = false;
			that.showratewin = false;
			if (type == 0) {
				Utils.$emit('handleRermove', localStorage.getItem('tabname'));
			} else if (type == 1) {
				//保留界面上的信息，再下新单
				that.clearinput(false);
			} else if (type == 2) {
				//新增订单，清空界面上所有填写的
				that.clearinput(true);
			}
		},
		clearinput(clearall) {
			var that = this;
			that.p_pkval = '';
			that.pkval = '';
			that.showpdf = false;
			that.residential = 0;
			that.chooseclearanceindex = 0;
			that.chooseshopindex = 0;
			that.shopname = '';
			that.expresscomname='';
			//that.iscopy=0;
			var model1 = that.model1;
			if (clearall) {
				for (var i = 0; i < model1.length; i++) {
					if (model1[i].l_mode == '订单号' || model1[i].l_mode == '门店') {
						model1[i].value = '';
					}
					if (model1[i].l_mode == '渠道') {
						that.p_mode = '';
						that.mode = '';
					}
					if (model1[i].l_mode == '寄件人信息' || model1[i].l_mode == '收件人信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].coldefault != '') children[j].value = children[j].coldefault;
							else children[j].value = '';
						}
						if (model1[i].l_mode == '寄件人信息') {
							if (that.addressinfo != '') {
								var addressinfo = JSON.parse(JSON.stringify(that.addressinfo));
								model1[i].children.forEach(sender => {
									for (var key in addressinfo) {
										if (sender.colname == key) {
											sender.value = addressinfo[key];
										}
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								});
							}
						}
					}
					if (model1[i].l_mode == '包裹信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype != 'table') {
								if (children[j].controltype == 'combox-input') {
									var volume = children[j].combox;
									for (var k = 0; k < volume.length; k++) {
										volume[k].value = '';
									}
								} else children[j].value = '';
							} else {
								that.cargolist = [];
							}
						}
					}
					if (model1[i].l_mode == '附加信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype == 'checkbox') {
								if (children[j].coldefault) {
									children[j].value = '1';
								} else {
									children[j].value = '0';
								}
							} else {
								children[j].value = '';
							}
						}
					}
				}
			}
		},
		//地址联动选择
		addrinput(val, i, modelindex) {
			this.$tool.addrlink(this, val, modelindex, i);
		},
		//文本框输入时自动提示
		inputsuggestions(querystring, cb, i, modelindex) {
			if (i.colevent != '') {
				this.$tool.addrlink_call(this, modelindex, i, cb);
			}
		},
		//选中提示选项时
		handleSelect(item, i, modelindex) {
			var that = this;
		},
		//文本框改变
		text_change(val, i, modelindex) {
			if (i.colevent != '') {
				this.$tool.addrlink(this, val, modelindex, i);
			}
		},
		enterinput(event, i, modelindex) {
			//console.log(val);
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') this.$refs[i.colnext][0].focus();
				} else if (event.keyCode == 37) {
					if (i.colperv != '') this.$refs[i.colperv][0].focus();
				}
			}
		},
		checkchange(val, control, i) {
			if (val == '1') {
				this.$refs[control][0].$el.style.display = 'inline-block';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'inline-block';
				}
			} else {
				if (i != undefined) i.value = '';
				this.$refs[control][0].$el.style.display = 'none';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'none';
				}
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		checkinput(event, i, modelindex) {
			if (i.colname == 'ctphone') {
				if (i.value != '') {
					if (i.coltype == 'phone_10') {
						if (i.value.length < 10) {
							this.$tool.message(i.showname + '不能少于10位', 0);
							this.$refs[i.colname][0].focus();
						}
					}
				}
			}
		},		
		//预览面单
		perviewmd() {
			this.$tool.loading('正在获取打印模板', 'createorder');
			this.$refs.printhandler.init({
				pageparam: this._data,
				isgrid: false,
				pkval: this.p_pkval,
				searchinfo: '',
				funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
				handtype: 3, //1--取单号 2--取快递单并打印 3-取快递单并预览
				isrollback: false,
				ecode: this.expresscomid,
				expresscomname: this.expresscomname,
				parentpage: this,
				isprint: 0
			});
		}
	}
};
</script>
